export const tenderState = {
  loading: false,
  response: null,
  error: false,
  tender: null,
};
